import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export const GuideWrap = styled.ul`
  text-align: center;

  li {
    font-size: 13px;
    line-height: 16px;
    color: ${({ $textColor }) => $textColor};
    position: relative;

    span {
      position: relative;
      white-space: pre;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 5px;
        left: -10px;
        width: 4px;
        height: 4px;
        background: ${({ $textColor }) => $textColor};
        border-radius: 50%;
      }
    }
  }
`;

const Guide = ({ style, $textColor = '#c2c2c2' }) => {
  const { t } = useTranslation();

  return (
    <GuideWrap style={style} $textColor={$textColor}>
      <li>
        <span>{t('WILL_BE_REMOVED_IN_24_HOURS')}</span>
      </li>
    </GuideWrap>
  );
};

export default Guide;
